
import React, { lazy, Suspense } from 'react'
import { TbPencil } from 'react-icons/tb'
import { Box, Checkbox, Col, FabButton, Flex, Row, Typography } from '../../../ppui'
import { formatNumberToFixed, parseNumericValue } from '../../../utils/common'
import ErrorBoundary from '../../../utils/error-boundary'
import { logger } from '../../../utils/logger'
import { AllowanceBox } from '../../style'
import OtherAdjustAllowance from './other-adjust-allowance'
import { SALARY_KNOWN_BASIC, SALARY_TYPE_SALARY } from './pay-benefit-const'


const  AllowanceForm=lazy(()=>import("./allowance-form"))

const AllowanceList = ({serviceProps
}) => {

    const {
        handleCheckAllowance
        ,allowanceList,allowancedialogOpen, setsetAllowancedialogOpen,
        employeePayBenefits,
        getAllowanceInputFieldPropsFn,
        allowance, setAllowance, handleAllownceChangeFunction,onSubmitAllowanceHandler,employeeEPFInfo}=serviceProps;
      


        const isEpfEgiliable = employeeEPFInfo?.employeeStatutoryData?.epf_availability;
        const isEsiEgiliable = employeeEPFInfo?.employeeStatutoryData?.esi_availability
        ;


       logger.log(allowanceList,"allowanceList")
  return (
    <> 
    <Flex justifyContent="space-between" mb={18} gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Employee Allowance data
            </Typography>
         
          </Flex>
          <Flex gap={20} direction={"column"}>
         {allowanceList?.map(it=>(  <AllowanceBox key={it?.allowanceId} >
              <Row alignItems="center">
                <Col xs={"auto"}>
                  <Checkbox 
                  onChange={()=>{
                    handleCheckAllowance(it)}}
                    checked={it?.isChecked}
                  color="primary" />
                </Col>
                <Col>
                  <Row alignItems="center" gap={{ md: 20, lg: 30, xxl: 60 }}>
                    <Col md={5} xl={4}>
                      <Box className="value">{it?.allowanceName} allowance</Box>
                      <Box className="value">
                        {it?.allowanceType === "percentage" ?
                          (<>
                            {it?.allowanceValue}%  of basic (₹{`${ formatNumberToFixed(parseNumericValue(employeePayBenefits?.basic_salary)*(parseNumericValue(it?.allowanceValue)/100))}`})
                          </>) :
                          (<>
                            ₹{it?.allowanceValue} {it?.allowanceType} Amount 
                          </>)
                        }
                      </Box>
                    </Col>
                    <Col >
                      <Box className="label">In Gross Wages</Box>
                      <Box className="value" color={it?.addToGross ? "success" : "danger"}>{it?.addToGross ? "Included" :"Not Included"}</Box>
                    </Col>
                    {isEsiEgiliable &&
                    <Col >
                      <Box className="label">In ESI Wages</Box>
                      <Box className="value" color={it?.isEsiWages ? "success" : "danger"}>{it?.isEsiWages ? "Included" :"Not Included"}</Box>
                    </Col>
                    }
                    {isEpfEgiliable &&
                    <Col>
                      <Box className="label">In EPF Wages</Box>
                      <Box className="value" color={it?.isEpfWages ? "success" : "danger"}>{it?.isEpfWages ? "Included" :"Not Included"}</Box>
                    </Col>
                    // <Col md={5} xl={3}>
                    //   <Box className="label" color={(!it?.isEpfWages && !it?.isEsiWages) && "danger"}>{(!it?.isEpfWages && !it?.isEsiWages) && "Not "} Included in </Box>
                    //   <Box className="value">{it?.isEpfWages && "EPF"}{(it?.isEpfWages && it?.isEsiWages) && " & "}{it?.isEsiWages && "ESI"} {(!it?.isEpfWages && !it?.isEsiWages) && "EPF & ESI"} wages</Box>
                    // </Col>
                    }
                    <Col>
                      <Box className="label"> Pay For</Box>
                      <Box className="value">{it?.noWorkNoPay ? "Present Days" : "Payable Days"}</Box>
                    </Col>
                  </Row>
                </Col>
    
                <Col xs={"auto"}>
                  <Box>
                    <FabButton
                      size="sm"
                      icon={<TbPencil />}
                      onClick={() => {
                        setAllowance(it)
                        setsetAllowancedialogOpen(true)}}
                      variant="filled"
                      shape="box"
                    />
                  </Box>
                </Col>
              </Row>
            </AllowanceBox>)) }
    
         { employeePayBenefits.salary_type ===SALARY_TYPE_SALARY &&  employeePayBenefits.salary_known !==SALARY_KNOWN_BASIC &&  parseNumericValue(employeePayBenefits.basic_salary)> 0 && parseNumericValue(employeePayBenefits.ctc_salary)  > 0 &&  <OtherAdjustAllowance  serviceProps={serviceProps}/>}
          
          </Flex>
          
         
      <ErrorBoundary fallback={<div>Something went wrong</div>}>

<Suspense fallback={<p>Loading dialog....</p>}>

<AllowanceForm  
handleChangeFunction={handleAllownceChangeFunction}
allowance={allowance}
onSubmitAllowanceHandler={onSubmitAllowanceHandler}
getInputFieldProps={getAllowanceInputFieldPropsFn}
allowancedialogOpen={allowancedialogOpen}
setsetAllowancedialogOpen={setsetAllowancedialogOpen}
totalAllowance={serviceProps?.totalAllowance}
empStatutory={employeeEPFInfo}
/>
</Suspense>
</ErrorBoundary>  
        
          
          </>
  )
}

export default AllowanceList